if (!customElements.get("set-recently-viewed") && !customElements.get("recently-viewed")) {
  class SetRecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.productHandle = this.dataset.productHandle;
    }

    connectedCallback() {
      setTimeout(() => {
        this.setRecentlyViewedProducts();
      }, 0);
    }

    setRecentlyViewedProducts() {
      const productHandles = this.getProductHandles(this.productHandle);
      let productHandlesArray = [];
      if (productHandles) {
        try {
          productHandlesArray = decodeURI(productHandles).split(",").filter(handle => handle && handle.trim() !== "");
        } catch (error) {
          console.error("Error decoding recently viewed products:", error);
          // Clear corrupted cookie
          Cookies.remove("recentlyViewed", { path: "/" });
          return;
        }
      }

      let productsToRender = productHandlesArray;

      if (this.productHandle) {
        if (productHandlesArray.includes(this.productHandle)) {
          productsToRender = productHandlesArray.filter((handle) => {
            return handle !== this.productHandle;
          });
        } else {
          let newHandles = [this.productHandle].concat(productHandlesArray);
          this.setCookieProducts(newHandles);
        }
      }
    }

    getProductHandles(productHandle) {
      let productHandles = Cookies.get("recentlyViewed");
      if (!productHandles || productHandles === "undefined" || productHandles === "") {
        if (productHandle) {
          Cookies.set("recentlyViewed", productHandle, {
            expires: 30,
            path: "/",
          });
          productHandles = Cookies.get("recentlyViewed");
        } else {
          return null;
        }
      }
      return productHandles;
    }

    setCookieProducts(productHandlesArray) {
      // Filter out empty or invalid handles before saving
      const validHandles = productHandlesArray.filter(handle => handle && handle.trim() !== "");
      
      if (validHandles.length === 0) {
        // If no valid handles, remove the cookie
        Cookies.remove("recentlyViewed", { path: "/" });
        return;
      }
      
      Cookies.set("recentlyViewed", validHandles.join(","), {
        expires: 30,
        path: "/",
      });
    }
  }
  customElements.define("set-recently-viewed", SetRecentlyViewed);
}